import { MerchantAccountStatusOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchMerchantAccountStatus = () =>
  driverApi.get<void, MerchantAccountStatusOutput>('/v1/merchant/account/status');

export const useFetchMerchantAccountStatus = (
  options: QueryOptions<typeof queryKeys.user.fetchMerchantAccountStatus, MerchantAccountStatusOutput> = {},
) => useQuery(queryKeys.user.fetchMerchantAccountStatus(), fetchMerchantAccountStatus, options);
